const SvgLogo = (props) => {
  const wordmark = (props.variant || "").trim().toLowerCase() === "wordmark";
  const viewBox = wordmark ? "0 0 1221 380" : "0 0 161 234";

  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      viewBox={viewBox}
      height={props.height}
      style={props.style}
    >
      {wordmark ? (
        <>
          <path
            fill={"#1b1c1c"}
            d={
              "M137.1 303.6c-13.6 7.9-29 11.8-45.9 11.8s-35.2-4.1-49-12.4-24.2-19.5-31.4-33.7S0 239.3 0 222.1s3.8-33.8 11.5-48.3 18.5-26 32.7-34.5c14.1-8.5 30.4-12.7 48.8-12.7s29.5 3.1 42 9.3c12.4 6.2 23 15.3 31.6 27.3l-30.9 25.5c-10.5-15.6-24.8-23.3-42.7-23.3s-27.8 5.1-36.6 15.4c-8.9 10.3-13.3 23.4-13.3 39.5s4.7 29.1 14.2 39.8c9.4 10.8 22.1 16.1 37.9 16.1s18.5-2.4 26.9-7.4c8.4-4.9 15.2-11.8 20.5-20.6l29.1 21.2c-9.3 14.8-20.8 26.2-34.5 34.1m104.4-42.1c9.3 10.4 21.6 15.6 37 15.6s28.1-5.1 37.7-15.4 14.4-23.8 14.4-40.6-4.8-30-14.5-40.4-22.3-15.6-37.9-15.6-28.2 5.3-37.1 16c-9 10.6-13.5 24-13.5 40s4.7 30 14 40.4m137.7 9.9c3.6 3.4 8.1 5 13.6 5s9.7-1.3 14-3.9l10 31.9c-11 7.4-22.7 11.1-35.2 11.1s-21.4-3.2-29.8-9.5-13.4-15-15.1-26c-6.2 11.5-15.1 20.3-26.6 26.4s-24.9 9.2-40.2 9.2-32.7-4.2-45.8-12.6q-19.5-12.6-30-33.9c-6.9-14.2-10.4-30.1-10.4-47.5s3.4-33.4 10.2-47.7c6.8-14.4 16.7-25.8 29.8-34.3 13-8.5 28.5-12.7 46.5-12.7s27.2 2.8 37.7 8.3 18.3 13.3 23.3 23.3v-27.3h42.3v125.2c0 6.7 1.8 11.7 5.4 15.1m181.2 32.2c-13.6 7.9-28.9 11.8-45.9 11.8s-35.2-4.1-49-12.4-24.2-19.5-31.4-33.7-10.8-30-10.8-47.2 3.8-33.8 11.5-48.3 18.5-26 32.7-34.5c14.1-8.5 30.4-12.7 48.8-12.7s29.5 3.1 42 9.3c12.4 6.2 23 15.3 31.6 27.3l-30.9 25.5c-10.5-15.6-24.8-23.3-42.7-23.3s-27.8 5.1-36.6 15.4c-8.9 10.3-13.3 23.4-13.3 39.5s4.7 29.1 14.2 39.8c9.4 10.8 22.1 16.1 37.9 16.1s18.5-2.4 26.9-7.4c8.4-4.9 15.2-11.8 20.5-20.6l29.1 21.2c-9.3 14.8-20.8 26.2-34.5 34.1m102.7-124.1v133.9h-39.4V179.4h-16.9v-36.8h16.9V80.1h39.4v62.5h30.7v36.8zm217.2 133.9H838v-29.8c-6.2 10-13.8 17.9-22.8 23.5q-13.5 8.4-33.9 8.4c-19.4 0-35.1-5.8-47.2-17.4S716 269.4 716 246.9V131h43.4v106.9c0 12.9 2.9 22.6 8.8 29.1s14.2 9.7 24.9 9.7 23.4-4.5 31.6-13.6c8.1-9.1 12.2-21.3 12.2-36.6V131h43.4zm126.5-145.5q-12.15-4.5-23.7-4.5c-7.7 0-14.2 1.7-19 5-4.8 3.4-7.2 7.9-7.2 13.6s2.7 10.7 8.3 13.3c5.5 2.6 15.3 5.3 29.4 7.9 13.4 2.6 24.5 5.5 33.4 8.6s16.4 8.1 22.8 15.1c6.3 6.9 9.5 16.5 9.5 28.7 0 18.2-7 32.7-21 43.6s-31.8 16.3-53.3 16.3-30.6-3-45-9c-14.5-6-26.7-14.5-36.8-25.5l24-30.1c7.2 8.9 16.5 15.6 28 20.1s22.7 6.8 33.7 6.8 14.7-1.5 19.7-4.5 7.5-7.2 7.5-12.7-2.6-10-7.7-12.7-13.8-5.3-26-7.7c-13.9-2.6-25.4-5.6-34.6-8.8s-17.3-8.6-24.2-16.2c-6.9-7.5-10.4-17.9-10.4-31s6.6-32.6 19.7-42.5c13.2-9.9 29.4-14.9 48.8-14.9s25 2.2 37 6.6 22.1 10.8 30.5 19.2l-22.6 28.4c-5.7-5.7-12.7-10.1-20.8-13.1"
            }
          />
          <path
            fill={"#30ac65"}
            d={
              "M1139.7 233.4c-11.1 0-20.1-9.1-20.1-20.4V20.4c0-11.3 9-20.4 20.1-20.4s20.1 9.1 20.1 20.4V213c0 11.3-9 20.4-20.1 20.4m-59.4-84c-11.1 0-20.1-9.1-20.1-20.4V58.5c0-11.3 9-20.4 20.1-20.4s20.1 9.1 20.1 20.4V129c0 11.3-9 20.4-20.1 20.4m118.7 0c-11.1 0-20.1-9.1-20.1-20.4V90.5c0-11.3 9-20.4 20.1-20.4s20.1 9.1 20.1 20.4V129c0 11.3-9 20.4-20.1 20.4"
            }
          />
          <path
            fill={"#d11d82"}
            d={
              "M1203.3 59.1c.9-4.5 3.8-12.7 14-13.9 1.79-.21 3.1-1.7 3.1-3.5s-1.2-3.3-2.9-3.7c-4.4-.9-12.5-3.9-13.7-14.2-.2-1.8-1.7-3.1-3.5-3.1-1.7 0-3.2 1.2-3.6 2.9-.9 4.5-3.8 12.7-14 13.9-1.8.2-3.1 1.7-3.1 3.5s1.2 3.3 2.9 3.7c4.4.9 12.5 3.9 13.7 14.2.28 2.4 1.7 3.1 3.5 3.1 1.7 0 3.2-1.2 3.6-2.9"
            }
          />
        </>
      ) : (
        <>
          <path
            fill={"#30ac65"}
            d={
              "M79.5 233.4c-11.1 0-20.1-9.1-20.1-20.4V20.4C59.4 9.1 68.4 0 79.5 0s20.1 9.1 20.1 20.4V213c0 11.3-9 20.4-20.1 20.4m-59.4-84C9 149.4 0 140.3 0 129V58.5c0-11.3 9-20.4 20.1-20.4s20.1 9.1 20.1 20.4V129c0 11.3-9 20.4-20.1 20.4m118.7 0c-11.1 0-20.1-9.1-20.1-20.4V90.5c0-11.3 9-20.4 20.1-20.4s20.1 9.1 20.1 20.4V129c0 11.3-9 20.4-20.1 20.4"
            }
          />
          <path
            fill={"#d11d82"}
            d={
              "M143.1 59.1c.9-4.5 3.8-12.7 14-13.9 1.79-.21 3.1-1.7 3.1-3.5s-1.2-3.3-2.9-3.7c-4.4-.9-12.5-3.9-13.7-14.2-.2-1.8-1.7-3.1-3.5-3.1-1.7 0-3.2 1.2-3.6 2.9-.9 4.5-3.8 12.7-14 13.9-1.8.2-3.1 1.7-3.1 3.5s1.2 3.3 2.9 3.7c4.4.9 12.5 3.9 13.7 14.2.28 2.4 1.7 3.1 3.5 3.1 1.7 0 3.2-1.2 3.6-2.9"
            }
          />
        </>
      )}
    </svg>
  );
};

const LogoCactus = (props) => {
  return <SvgLogo {...props} />;
};

export default LogoCactus;
